const isDevEnvironment =
  typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production'

type LogDetails = Record<string, unknown> | undefined

export function warnInbox(message: string, details?: LogDetails): void {
  if (!isDevEnvironment) {
    return
  }

  if (details) {
    console.warn(message, details)
  } else {
    console.warn(message)
  }
}

export function ensureCallable<Args extends unknown[]>(
  handler: ((...args: Args) => unknown) | undefined,
  label: string,
  details?: LogDetails,
): handler is (...args: Args) => unknown {
  if (typeof handler !== 'function') {
    warnInbox(`[Inbox] Missing handler: ${label}`, details)
    return false
  }

  return true
}
